export const SYSTEM_MESSAGE_STYLE = {
  borderRadius: 10,
  background: "var(--kjuup-bg)",
  textAlign: "center",
  color: "#3c3c3c",
  fontSize: "12px",
};

export const MENTIONS_INPUT_STYLE = {
  control: {
    backgroundColor: 'transparent',
    fontSize: "var(--kjuup-type-body)",
    fontWeight: 'normal',
    minHeight: 40,
  },
  highlighter: {
    padding: 9,
    border: 'none',
  },
  input: {
    padding: 9,
    border: 'none',
    outline: 'none',
  },
  suggestions: {
    zIndex: 99999,
    backgroundColor: 'white',
    borderRadius: 10,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      borderRadius: 10,
      maxHeight: 200,
      overflowY: 'auto',
    },
    item: {
      padding: '10px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.1)',
      cursor: 'pointer',
      '&focused': {
        backgroundColor: 'var(--kjuup-bg)',
      },
    },
  },
};

export const MENTION_SUGGESTIONS_CONTAINER_STYLE = {
  padding: 10,
  backgroundColor: "var(--kjuup-bg)",
};

export const MENTION_SUGGESTION_ROW_STYLE = {
  display: "flex",
  flexDirection: "row",
  borderBottom: "1px solid #dfdfdf",
  paddingBottom: 10,
  marginBottom: 10,
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "pointer",
};

export const MENTION_AVATAR_STYLE = {
  height: 35,
  width: 35,
  borderRadius: 5,
  objectFit: 'cover',
};

export const MENTION_NAME_WRAPPER_STYLE = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  paddingLeft: 10,
};
